export const DELIVERY_STATUS = {
  BOUNCED: "bounced",
  DELIVERED: "delivered",
  SPAM: "spam",
  OPENED: "opened",
  UNSUBSCRIBED: "unsubscribed",
  SENT: "sent",
  REJECTED: "rejected",
  SIZE_EXCEEDED: "sizeExceeded",
  FAILED: "failed",
} as const;

export type DeliveryStatus = (typeof DELIVERY_STATUS)[keyof typeof DELIVERY_STATUS];

export const DELIVERY_ISSUES = [
  DELIVERY_STATUS.BOUNCED,
  DELIVERY_STATUS.REJECTED,
  DELIVERY_STATUS.FAILED,
  DELIVERY_STATUS.SIZE_EXCEEDED,
  DELIVERY_STATUS.SPAM,
  DELIVERY_STATUS.UNSUBSCRIBED,
];
